/**
 *  DEFAULT: The default date picker style from Buefy.
 *  INLINE_CALENDAR: Datetime input with an inline calendar always visible.
 *  DROPDOWN_CALENDAR: Datetime input with an optional user-controlled calendar.
 */
var DatePickerType;
(function (DatePickerType) {
    /** The default date picker style from Buefy. */
    DatePickerType["DEFAULT"] = "default";
    /** Datetime input with an inline calendar always visible. Uses custom input with autocomplete */
    DatePickerType["INLINE_CALENDAR"] = "inline-calendar";
    /** Datetime input with an optional dropdown calendar. Uses custom input with autocomplete */
    DatePickerType["DROPDOWN_CALENDAR"] = "dropdown-calendar";
})(DatePickerType || (DatePickerType = {}));

export { DatePickerType };
